import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=050c2efc&scoped=true&"
import script from "./OrgList.vue?vue&type=script&lang=js&"
export * from "./OrgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c2efc",
  null
  
)

export default component.exports